import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import useSeo, { buildBreadcrumb } from "../lib/useSeo";
import {
  Code2, Smartphone, Globe, Users, Network, BarChart3, Rocket, Lightbulb, ArrowUpRight,
} from "lucide-react";

const ICONS = { Code2, Smartphone, Globe, Users, Network, BarChart3, Rocket, Lightbulb };

export default function Soluciones() {
  useSeo({
    title: "Soluciones · Software a medida, Apps, MVPs y BI · DoSoft Chile",
    description: "Catálogo de soluciones DoSoft: software a medida, aplicaciones móviles y web, software factory, digitalización, business intelligence, pilotos, MVPs y asesoría en innovación para empresas en Chile.",
    canonical: "https://dosoft.cl/soluciones",
    jsonLd: [
      buildBreadcrumb([
        { name: "Inicio", url: "/" },
        { name: "Soluciones", url: "/soluciones" },
      ]),
    ],
  });
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="soluciones-page">
      <section className="border-b border-ink-500 py-24 md:py-32 relative overflow-hidden">
        <div className="absolute inset-0 grid-lines opacity-20" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12">
          <div className="text-xs uppercase tracking-widest text-brand font-mono mb-6">
            Soluciones
          </div>
          <h1 className="font-display font-black text-5xl md:text-7xl tracking-tighter text-ash-100 max-w-4xl leading-[0.95]">
            Productos digitales<br />listos para crecer contigo.
          </h1>
          <p className="text-ash-300 mt-8 max-w-2xl text-lg leading-relaxed">
            Tipos de proyecto que sabemos hacer bien. Cada uno parte como un
            producto único, pensado para tu negocio.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-ink-500 border border-ink-500">
            {services.map((s, i) => {
              const Icon = ICONS[s.icon] || Code2;
              return (
                <div
                  key={s.id}
                  data-testid={`solucion-${s.slug}`}
                  className="bg-ink-800 p-6 group hover:bg-ink-700 transition-colors relative overflow-hidden flex flex-col"
                >
                  <div className="text-[10px] font-mono text-ash-500 mb-4">
                    0{i + 1}
                  </div>
                  <Icon size={22} strokeWidth={1.5} className="text-brand mb-4" />
                  <h3 className="font-display font-bold text-lg text-ash-100 mb-2 leading-tight">
                    {s.title}
                  </h3>
                  <p className="text-ash-300 mb-4 leading-relaxed text-sm">{s.subtitle}</p>
                  {s.features && s.features.length > 0 && (
                    <ul className="space-y-1.5 mb-5">
                      {s.features.slice(0, 3).map((f, j) => (
                        <li key={j} className="text-[12px] text-ash-300 flex items-start gap-2 leading-snug">
                          <span className="text-brand mt-1">—</span>
                          <span>{f}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                  <Link
                    to="/cotizador"
                    className="mt-auto inline-flex items-center gap-2 text-[10px] uppercase tracking-widest text-ash-100 hover:text-brand transition-colors"
                  >
                    Saber más <ArrowUpRight size={12} strokeWidth={1.5} />
                  </Link>
                </div>
              );
            })}
          </div>

          <div className="mt-16 border border-ink-500 bg-ink-900 p-10 md:p-16 text-center">
            <h2 className="font-display font-bold text-3xl md:text-4xl text-ash-100 mb-4">
              ¿Necesitas una solución a medida?
            </h2>
            <p className="text-ash-300 mb-8 max-w-2xl mx-auto">
              También construimos sistemas únicos diseñados específicamente para tu
              flujo operacional.
            </p>
            <Link
              to="/cotizador"
              data-testid="soluciones-cta-custom"
              className="inline-block bg-brand text-ink-800 font-semibold hover:bg-brand-hover px-8 py-4 uppercase tracking-wider text-sm"
            >
              Cotizar desarrollo a medida
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
